/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ci_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the difference between code point and UTF-8 bytes?`)
};

const es_ci_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre punto de código y bytes UTF-8?`)
};

const de_ci_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen Codepunkt und UTF-8-Bytes?`)
};

const nl_ci_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen codepunt en UTF-8-bytes?`)
};

const fr_ci_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre le point de code et les octets UTF-8 ?`)
};

const it_ci_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra punto di codice e byte UTF-8?`)
};

const pt_br2_ci_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre ponto de código e bytes UTF-8?`)
};

const pt_ci_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre ponto de código e bytes UTF-8?`)
};

const ja_ci_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「コードポイントと UTF-8 バイトの違いは何ですか?」`)
};

const zh_ci_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`码点和 UTF-8 字节有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ci_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ci_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ci_faq2_q", locale)
	if (locale === "en") return en_ci_faq2_q(inputs)
	if (locale === "es") return es_ci_faq2_q(inputs)
	if (locale === "de") return de_ci_faq2_q(inputs)
	if (locale === "nl") return nl_ci_faq2_q(inputs)
	if (locale === "fr") return fr_ci_faq2_q(inputs)
	if (locale === "it") return it_ci_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_ci_faq2_q(inputs)
	if (locale === "pt") return pt_ci_faq2_q(inputs)
	if (locale === "ja") return ja_ci_faq2_q(inputs)
	return zh_ci_faq2_q(inputs)
};